<template>
  <div id="contenedor-registrar-solicitud-de-pago">
    <template v-if="!solicitudPago">
      <v-tooltip top v-if="mixValidaScopesActions(2)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="mostrarRegistrarPago = !mostrarRegistrarPago"
          >
            <v-icon>mdi-currency-usd</v-icon>
          </v-btn>
        </template>
        <span>Registrar Pago</span>
      </v-tooltip>
    </template>
    <template v-else>
      <v-tooltip top v-if="mixValidaScopesActions(2)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="mostrarRemoverPago = !mostrarRemoverPago"
          >
            <v-icon>mdi-currency-usd-off</v-icon>
          </v-btn>
        </template>
        <span>Remover Pago</span>
      </v-tooltip>
    </template>
    <v-dialog
      v-if="mostrarRegistrarPago"
      v-model="mostrarRegistrarPago"
      width="450"
    >
      <v-form v-model="formularioValido" ref="registrarSolicitudPago">
        <v-card>
          <v-card-title class="secondary--text">
            Registrar pago
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
              <v-col cols="12" md="12">
                <custom-text-field
                  v-model="solicitud.folio"
                  label="Folio"
                  :rules="[mixReglas.requerido]"
                >
                </custom-text-field>
              </v-col>
              <date-picker
                v-model="solicitud.fecha"
                label="Fecha"
                cols="12"
                md="12"
                :rules="[mixReglas.requerido]"
              >
              </date-picker>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3"
            >
            </custom-button>
            <custom-button
              @click="guardar"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar"
            >
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="mostrarRemoverPago" width="450">
      <v-card>
        <v-card-title class="secondary--text">
          Eliminar Pago Registrado
        </v-card-title>
        <v-card-text>
          <span class="secondary--text"> ¿Desea eliminar el pago? </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="eliminar"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixRegistrarRemoverPago from './mixRegistrarRemoverPago';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'RegistrarNuevaSolicitudDePagoLite',
  mixins: [mixRegistrarRemoverPago],
  props: {
    referencia: {
      type: Object,
      required: true,
    },
    solicitudPago: {
      type: Object,
      required: false,
    },
  },
  components: {
    CustomTextField,
    DatePicker,
    CustomButton,
  },
  data() {
    return {
      solicitudPagoEliminar: {},
      mostrarRegistrarPago: false,
      mostrarRemoverPago: false,
      formularioValido: false,
      enviandoFormulario: false,
      referenciasSeleccionadas: [],
      solicitud: {
        idContrato: this.referencia.idContrato,
        folio: '',
        fecha: '',
        detalles: [],
      },
      solicitudReferencia: {
        idReferencia: '',
        numeroFactura: '',
        fechaFactura: new Date().toISOString().substr(0, 10),
        importe: 0,
      },
    };
  },
  mounted() {
    this.solicitudReferencia.idReferencia = this.referencia.id;
    this.solicitudReferencia.importe = this.referencia.total ? this.referencia.total : 0;
  },
  methods: {
    limpiarFormulario() {
      if (this.mostrarRegistrarPago) {
        this.solicitud.fecha = null;
        this.$refs.registrarSolicitudPago.reset();
      }
    },
    cerrar() {
      this.limpiarFormulario();
      this.mostrarRegistrarPago = false;
      this.mostrarRemoverPago = false;
    },
    async eliminar() {
      this.solicitudPagoEliminar = this.solicitudPago;
      await this.mixEliminarSolicitudPago();
    },
    async guardar() {
      this.solicitud.detalles.push(this.solicitudReferencia);

      await this.mixGuardarSolicitudPago();
    },
  },
  watch: {
    referencia: {
      handler({ id, total }) {
        this.solicitudReferencia.idReferencia = id;
        this.solicitudReferencia.importe = total;
      },
    },
  },
};
</script>

<style lang="scss">
</style>
